var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.statusData.variant}},[_vm._v(" "+_vm._s(_vm.statusData.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }